export default "__VITE_ASSET__B$93qyGM__"